import { Component } from '@angular/core';
import {Store} from "@ngrx/store";
import {selectUserDisabled} from "../../../store/selectors/users.selectors";

@Component({
  selector: 'app-user-not-found-controller',
  templateUrl: './user-not-found-controller.component.html',
  styleUrls: ['./user-not-found-controller.component.scss']
})
export class UserNotFoundControllerComponent {
  userDisabled$ = this.store.select(selectUserDisabled);

  constructor(private store: Store) {
  }
}
